import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import DealerNameOverride from './DealerNameOverride';

const DealerOverrides = ({ onChange, className, name }) =>
  (
    <Paper
      className={className}
      style={{ padding: 20 }}
    >
      <DealerNameOverride
        name={name}
        onChange={onChange}
      />
    </Paper>
  );

DealerOverrides.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

export default DealerOverrides;



// WEBPACK FOOTER //
// ./src/feed-overrides/components/DealerOverrides.jsx